module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_23-30d3b676439821b7e78e2766a42363e8.jpg";